<template>
  <div class="h5">
    <header>
      <span class="back" @click='back()'></span>
      <span>优质推荐</span>
      <span class="more"></span>
    </header>
    <iframe :src="url" frameborder="0" width="100%" class="iframe"></iframe>
  </div>
</template>

<script>
import { API_1, Global } from "../conf/api";
import { hexMD5 } from "../tools/md5";
import "../assets/css.css";
export default {
  name: "login",
  components: {},
  data() {
    return {
      url: "",
      token: "",
      userid: "",
      userimg: "",
      username: "",
      account: "",
      password: "",
      phoneNum: "",
      code: "",
      oneMinute: "",
      timeBtn: true,
      accountLog: true,
      phoneLog: false,
      codeDialog: false,
      codeImg: "",
      codeKey: "",
      imgCode: "",
      wait: 60,
    };
  },
  mounted() {
    this.url = this.$route.query.url;
    console.log(this.url, "dd");
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
header{position: fixed;
    width: 100%;}
.iframe{ height: 100vh;}
.login {
  width: 100%;
  padding: 0 40px;
}
.el-input__inner {
  border: none;
  border-bottom: 1px solid #DCDFE6;
}
.log_btn.is-round {
  padding: 12px 120px;
}
.log1_btn.is-round {
  margin-top: 20px;
  margin-left: 0px;
  padding: 12px 80px;;
}
.log2_btn.is-round {
  margin-top: 20px;
  margin-left: 0px;
  padding: 12px 92px;;
}
</style>
